import { render, staticRenderFns } from "./ReinforcingSystemsGovernance.vue?vue&type=template&id=16fe2ec6&"
import script from "./ReinforcingSystemsGovernance.vue?vue&type=script&lang=js&"
export * from "./ReinforcingSystemsGovernance.vue?vue&type=script&lang=js&"
import style0 from "./ReinforcingSystemsGovernance.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports